"use client";

import { isChunkLoadError, reloadOnceForChunkError } from "@/lib/chunk-error";
import { useTranslations } from "next-intl";
import React from "react";
import { ErrorBoundary } from "react-error-boundary";

function ErrorFallback({
    error,
    resetErrorBoundary,
}: {
    error: unknown;
    resetErrorBoundary: () => void;
}) {
    const t = useTranslations("common");
    React.useEffect(() => {
        // A dynamic import that failed during render (stale chunk after a deploy)
        // is only recoverable with a fresh page load — reset() would re-run the
        // same failing import.
        if (isChunkLoadError(error)) {
            reloadOnceForChunkError();
        }
    }, [error]);

    return (
        <div className="flex min-h-screen flex-col items-center justify-center p-4">
            <div className="w-full max-w-md rounded-lg bg-white p-8 shadow-lg">
                <h2 className="mb-4 text-2xl font-bold text-red-600">
                    {t("errorTitle")}
                </h2>
                <p className="mb-4 text-gray-600">{t("errorBody")}</p>
                <button
                    onClick={resetErrorBoundary}
                    className="w-full rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
                >
                    Tekrar Dene
                </button>
            </div>
        </div>
    );
}

export default function ErrorBoundaryClient({
    children,
}: {
    children: React.ReactNode;
}) {
    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            {children}
        </ErrorBoundary>
    );
}
